import React from 'react'
import TopMenu from './TopMenu'
import { Outlet } from 'react-router-dom'
import Footer from './Footer'
const Layout = () => {
    return (
        <>
            <TopMenu />
            <Outlet />
            <Footer />
        </>
    )
}

export default Layout
